import React from 'react';
import { IMPACT_STATUS_MAP } from '../../../ImpactEvaluation/constants';
import { ImpactEvaluationStatus } from 'types/evaluation';
import './style.scss';

interface ImpactEvaluationIconStatus {
    isDisabled: boolean;
    title: string;
    className: string;
}

interface ImpactEvaluationIconProps {
    status: ImpactEvaluationIconStatus;
    onClick: () => void;
}

const getStatusFromTitle = (title: string): ImpactEvaluationStatus => {
    if (title.includes('já respondida')) {
        return ImpactEvaluationStatus.FINISHED;
    }
    if (title.includes('expirada')) {
        return ImpactEvaluationStatus.EXPIRED;
    } 
    return ImpactEvaluationStatus.PENDING;
};

const ImpactEvaluationIcon: React.FC<ImpactEvaluationIconProps> = ({ status, onClick }) => {
    const evaluationStatus = getStatusFromTitle(status.title);
    const statusConfig = IMPACT_STATUS_MAP[evaluationStatus];
    
    return (
        <div
            title={statusConfig.tooltip}
            className={`impact-evaluation-icon__container ${status.isDisabled ? 'impact-evaluation-icon__container--disabled' : ''}`}
            style={{
                color: statusConfig.fontColor,
            }}
            onClick={status.isDisabled ? undefined : (e) => {
                e.stopPropagation();
                onClick();
            }}
        >
            {statusConfig.icon}
        </div>
    );
};

export default ImpactEvaluationIcon;
